exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.on-left[data-v-4de26cee]{margin-top:-5px;margin-right:5px\n}\n.content-table[data-v-4de26cee]{margin:25px 10%\n}\n@media(max-width: 945px){\n.content-table[data-v-4de26cee]{margin-left:5px;margin-right:5px\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4de26cee","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/mediaItem/MediaItemList.vue
// module id = 187
// module chunks = 0